import { render, staticRenderFns } from "./OfficeView.vue?vue&type=template&id=6aa6fe6d"
import script from "./OfficeView.vue?vue&type=script&lang=js"
export * from "./OfficeView.vue?vue&type=script&lang=js"
import style0 from "./OfficeView.vue?vue&type=style&index=0&id=6aa6fe6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports